import React from "react";
import Ayurvedic from "../assets/ayurvedic.webp";
import DietImg from "../assets/services/Diet.webp";
import FastingImg from "../assets/services/Fasting.webp";
import YogaImg from "../assets/services/yoga.webp";
import AirImg from "../assets/services/air.webp";
import MudBathImg from "../assets/services/mudbath.webp";
import HydroTherapyImg from "../assets/services/hydrotherapy.webp";
import SteamBathImg from "../assets/services/steambath.webp";
import PlantainLeafImg from "../assets/services/plantain_leaf.webp";
import MassageImg from "../assets/services/massage.webp";
import PhysiotherapyImg from "../assets/services/physiotherapy.webp";

// 🌿 Treatment Data Array mapping content directly with the client's images
const servicesData = [
  {
    title: "🥗 Diet Therapy",
    desc: "100% natural raw diet with different varieties of Fruits, Vegetables, Salads, Sprouts and Juices. These are useful for healing and promoting health.",
    // Default fallback or a general image path if your client sends one later
    img: DietImg 
  },
  {
    title: "⏳ Fasting Therapy",
    desc: "Fasting gives rest to the digestive system. During fasting only water and simple juices are given. It helps purification of body and mind and improves natural healing.",
    img: FastingImg
  },
  {
    title: "🧘 Yoga Therapy",
    desc: "Includes yoga asanas, pranayama, meditation, relaxation methods and yogic kriyas.",
    img: YogaImg
  },
  {
    title: "🏼 Air Therapy",
    desc: "Open fresh air walking and breathing techniques advised in various respiratory disorders.",
    img: AirImg
  },
  {
    title: "🌱 Mud Therapy",
    desc: "Different varieties of mud like Red Soil, Herbal Mud and Herbal Ganji are used. Mud therapy cools the body, tones the skin and removes skin diseases.",
    img: MudBathImg
  },
  {
    title: "💧 Hydro Therapy",
    desc: "Hydrotherapy uses water in different forms and temperatures to remove ailments. Different baths, tubs, packs and douches are used for treatment.",
    img: HydroTherapyImg
  },
  {
    title: "♨️ Steam Bath",
    desc: "Powerful treatment to eliminate toxins and reduce body pain and weight.",
    img: SteamBathImg
  },
  {
    title: "🍃 Heliotherapy : Plantain Leaf Bath",
    desc: "Sun bath helps nourish skin, muscles and bones. It opens skin pores and eliminates toxins through sweating. Effective for skin diseases, obesity and arthritis.",
    img: PlantainLeafImg
  },
  {
    title: "💆 Massage Therapy",
    desc: "Herbal oil massages improve blood circulation, reduce pain and increase relaxation. Techniques include Varma, Aroma, Hot Stone, Swedish and Thai Massage.",
    img: MassageImg
  },
  {
    title: "🏃‍♂️ Physiotherapy",
    desc: "Includes electro therapy and exercise therapy instruments. Helpful for painful conditions, muscle weakness, stroke and arthritis.",
    img: PhysiotherapyImg
  }
];

function Services() {
  return (
    <section className="bg-gradient-to-b from-white via-green-50 to-white px-6 py-16 md:px-16 min-h-screen font-poppins">
        
      {/* Heading */}
      <div className="text-center mb-14">
        <h1 className="text-3xl md:text-4xl font-black text-green-900 tracking-wide drop-shadow-sm">
          Our Treatments & Therapies
        </h1>
        <p className="text-neutral-900 leading-9 text-[18px] font-bold tracking-wide mt-2">
          Experience natural healing therapies for healthy living.
        </p>
      </div>

      {/* Introduction */}
      
      <div className="bg-white rounded-3xl shadow-xl p-8 mb-14 border border-green-100">
        <h2 className="text-3xl font-black text-green-800 mb-6">
          🌿 Introduction
        </h2>
        {/* FIXED: Changed to text-neutral-900 and font-bold */}
        <p className="text-neutral-900 leading-9 text-[17px] font-bold">
          Universal Goodlife Ashram is a Nature Cure and Yoga Centre
          with 100% natural living foods. It is an ideal place for
          natural cure treatments and yoga. All treatments are given
          through natural methods with healthy food, yoga and natural
          way of living.
        </p>
      </div>


      {/* Services Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {servicesData.map((service, index) => (
          <div 
            key={index} 
            className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden flex flex-col hover:-translate-y-2 hover:scale-105 transition duration-500 border border-green-200"
          >
            {/* Renders image dynamically if it exists for the card */}
            {service.img && (
              <div className="w-full h-48 overflow-hidden border-b border-green-100">
                <img 
                  src={service.img} 
                  alt={service.title}
                  loading="eager"
                  fetchPriority="high" 
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="p-7 flex-1 flex flex-col justify-between">
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-green-900 mb-4 tracking-wide">
                  {service.title}
                </h2>
                <p className="text-neutral-900 leading-9 text-[16px] font-bold">
                  {service.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Other Treatments Section */}
      <div className="mt-20 bg-white rounded-3xl shadow-xl p-10 border border-green-100">
        <h2 className="text-3xl font-black text-green-800 mb-10 text-center">
          Other Treatments
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Ayurvedic Treatments */}
          <div className="bg-green-50 rounded-3xl shadow-md p-6 hover:scale-105 transition duration-300 border border-green-100">
           <div>
              <div className="w-full h-48 overflow-hidden rounded-2xl mb-4 border border-green-200">
                <img 
                  src={Ayurvedic} 
                  alt="Ayurvedic Treatments" 
                  className="w-full h-full object-cover"
                />
              </div>
            <h2 className="text-2xl font-black text-green-900 mb-4 tracking-wide">
              🌿 Ayurvedic Treatments
            </h2>
            <p className="text-neutral-900 leading-9 text-[16px] font-bold">
              Massage, Elakizhi, Pichu, Kadivasti, Shirodhara and Thaila Dhara.
            </p>
          </div>
          </div>

          {/* Nature Cure */}
          <div className="bg-green-50 rounded-3xl shadow-md p-6 hover:scale-105 transition duration-300 border border-green-100">
            <h2 className="text-2xl font-black text-green-900 mb-4 tracking-wide">
              🍀 Nature Cure
            </h2>
            <p className="text-neutral-900 leading-9 text-[16px] font-bold">
              Nature Cure (Naturopathy) is an art and science of healthy living and a drugless system of healing. It teaches natural lifestyle, food habits and healthy routines for disease-free living.
            </p>
          </div>

          {/* Ailments Treated */}
          <div className="bg-green-50 rounded-3xl shadow-md p-6 border border-green-100">
            <h2 className="text-2xl font-black text-green-900 mb-4 tracking-wide">
              ❤️ Ailments Treated
            </h2>
            <ul className="grid grid-cols-2 gap-x-2 gap-y-3 text-neutral-900 font-extrabold text-[15px]">
              <li>✅ Obesity</li>
              <li>✅ Hypertension</li>
              <li>✅ Diabetes</li>
              <li>✅ Digestive</li>
              <li>✅ Arthritis</li>
              <li>✅ Back Pain</li>
              <li>✅ Knee Pain</li>
              <li>✅ Heart Issues</li>
              <li>✅ Stress</li>
              <li>✅ Nervous</li>
              <li>✅ Sinus</li>
              <li>✅ Asthma</li>
              <li>✅ Skin Diseases</li>
              <li>✅ Uterine problems</li>
            </ul>
          </div>
        </div>

        {/* Small Treatments Ribbon */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-center text-neutral-900 font-extrabold text-[15px] mt-12 pt-8 border-t border-green-100">
          <div className="bg-green-50 p-3 rounded-xl border border-green-100">✅ Facial</div>
          <div className="bg-green-50 p-3 rounded-xl border border-green-100">✅ Skin Toning</div>
          <div className="bg-green-50 p-3 rounded-xl border border-green-100">✅ Reflexology</div>
          <div className="bg-green-50 p-3 rounded-xl border border-green-100">✅ Accupressure</div>
          <div className="bg-green-50 p-3 rounded-xl border border-green-100">✅ Acupuncture</div>
          <div className="bg-green-50 p-3 rounded-xl border border-green-100">✅ Magneto</div>
        </div>

      </div>

    </section>
  );
}

export default Services;